<template>
  <tr v-if="ticket">
    <td class="hide-cell">
      <i class="fa fa-ticket" aria-hidden="true"></i>
    </td>

    <td class="hide-cell">{{ticket.details}}</td>

    <td :data-label="ticket.details" :colspan="colspan" v-if="!ticket.tickets_remaining == 0">
        Bookable on the next page
    </td>

    <td :colspan="colspan" class="textalignment" v-if="ticket.tickets_remaining == 0">
      <span class="label label-soldout">Sold Out</span>
    </td>
  </tr>
</template>

<script>

import ticketMixins from "./tickets-mixin";
import {mapGetters} from 'vuex';

export default {
  props: ["event", "ticket"],

  mixins: [ticketMixins],

  data() {
    return {
      ticketsSelected: 0
    };
  },

  computed: {
    ...mapGetters({
      hasPaidTickets: 'getChargeable'
    }),
    colspan(){
      var colspan = 1

      if (this.hasEarlyBird){
        colspan += 1
      }

       if (this.hasPaidTickets){
        colspan += 1
      }
     
       if (this.vatable){
        colspan += 2
      }

      if (this.event.show_tickets_remaining){
        colspan +=1
      }

      return colspan
    }
  }

};
</script>

<style scoped>
</style>
